import config from '../../../config';

export const ACTIVIDADES_LIST = [
  'Revitalización',
  'Equilibrio',
  'Suelo pélvico',
  'Ventilación',
  'TO',
  'VENREDI',
];

export const SECTION_IDS = ['datos', 'historial', 'medicacion', 'final'];

export const VIVEN_LABELS = { 0: 'Solo', 1: 'Pareja', 2: 'Familiares' };

export const GRUPOS_DICT = config.GRUPOS;
export const GRUPO_LABELS = config.GRUPOS;

export const EDUCACION_LABELS = {
  0: 'Analfabeto',
  1: 'Estudios primarios incompletos',
  2: 'Estudios primarios',
  3: 'Estudios secundarios',
  4: 'Otros',
};

export const SEXO_LABELS = { 1: 'Hombre', 2: 'Mujer' };
export const FUMADOR_LABELS = { 1: 'No', 2: 'Si', 3: 'Fue fumador' };
export const ALCOHOL_LABELS = { 1: 'No', 2: 'Si', 3: 'Consumía alcohol' };
